module.exports = __webpack_public_path__ + "static/media/credit-card-01.e1770f1b.svg";